import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import api from './api'
import localStorage from './utils/localStorage'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/reset.css'// 样式初始化
import '@/assets/style/index.css'// 媒体监听样式
import '@/assets/style/iconfont.css'// iconfont样式
import '@/utils/eldialogMove'// 对话框移动
import Router from 'vue-router'
import JsonExcel from 'vue-json-excel'// 导出excel插件
import Print from '@/utils/print'
import boyoFavicon from '@/assets/images/boyo.png'
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
// Vue.use(VueDirectiveImagePreviewer, {
//   background: {
//     color: "#000"
//   },
//   cursor: 'pointer',
//   clickMethod: 'doubleClick'
// })
Vue.component('downloadExcel', JsonExcel)
// require('./mock')//mock数据
const routerPush = Router.prototype.push
// Uncaught (in promise)报错
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.config.productionTip = false
Vue.use(ElementUI)// 饿了么插件
Vue.use(Print)
Vue.use(api)// api方法挂载到全局
Vue.use(localStorage)

const faviconLink = document.querySelector("link[rel~='icon']") || document.createElement('link')
faviconLink.rel = 'icon'
faviconLink.href = boyoFavicon
document.head.appendChild(faviconLink)

/* eslint-disable no-new */
// 金额展示千分位
Vue.directive("thousands", {
  // 被绑定元素插入父节点时调用
  inserted: function(el) {
    // 获取input节点
    if (el.tagName.toLocaleUpperCase() !== "INPUT") {
      el = el.getElementsByTagName("input")[0];
    }
    if (!el.value || el.value == '-') {
      return
    }
    // 千分位
    el.value = parseFloat(el.value).toLocaleString("zh", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    // 聚焦转化为数字格式（去除千分位）
    el.onfocus = e => {
      if (el.value) {
        let a = el.value.replace(/,/g, ""); //去除千分号的','
        el.value = Number(parseFloat(a).toFixed(2));
      }
    };
    el.onblur = e => {
      if (el.value) {
        el.value = parseFloat(el.value.replace(/,/g, "")).toLocaleString("zh", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });
      }
    };
  },
  update: function(el) {
    // debugger
    // 获取input节点
    if (el.tagName.toLocaleUpperCase() !== "INPUT") {
      el = el.getElementsByTagName("input")[0];
    }
    setTimeout(() => {
      if (!el.value || el.value == '-') {
        return
      }
      // 千分位格式化
      const valueWithoutComma = el.value.replace(/,/g, ""); // 去除千分号的','
      // 转换为浮点数
      const floatValue = parseFloat(valueWithoutComma);
      // 格式化为千分位
      el.value = floatValue.toLocaleString("zh", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }, 100);
  }
});
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js